import { TranslateLoader, TranslationObject } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { isDevMode } from "@angular/core";
import packageJson from "../../../../package.json";

const appVersion = packageJson?.version || "0.0.0";

export function HttpLoaderFactory(http: HttpClient) {
  return new ManifestTranslateLoader(http);
}

export class ManifestTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    if (isDevMode()) {
      return this.http.get<TranslationObject>(`/assets/i18n/${lang}.json`);
    }
    return this.http.get<TranslationObject>(`/assets/i18n/${lang}.${appVersion.replaceAll(".", "-")}.json`);
  }
}
